/* webpack-strip-block:removed */

/**
 * Creates a new stream with the supplied configuration.
 *
 * @param { Stream } stream
 * @return { Promise<Stream[] | undefined> }
 */
export const storeStream = async (stream) => {
  try {
    const response = await axios.post("/admin/streams/store", {
      ...stream,
    });

    if (response.data.success) {
      swal.fire("Success!", "This stream can now be assigned to a customer!", "success");
      return response.data.data.streams;
    } else {
      swal.fire("Oops!", "Stream already exists by this name and format!", "error");
    }
  } catch (e) {
    swal.fire("Oops!", "Oops, something went wrong!", "error");
  }
};

/**
 * Patches the stream indicated by `payload.oldName`.
 *
 * @param { string } old_name The existing stream name.
 * @param { Stream  } stream The new definition for the existing stream.
 * @return { Promise<Stream[] | undefined> }
 */
export const patchStream = async (old_name, stream) => {
  try {
    const response = await axios.patch("/admin/streams/patch", {
      oldName: old_name,
      newName: stream.name,
      format: stream.format,
      server: stream.server,
    });

    if (response.data.success) {
      swal.fire("Success!", "This stream has been updated!", "success");
      return response.data.data.streams;
    } else {
      swal.fire("Oops!", "Stream was not changed", "info");
    }
  } catch (e) {
    swal.fire("Oops!", "Oops, something went wrong!", "error");
  }
};

/**
 * Updates (overwrites) the streams for the given customer.
 *
 * @param { Customer } customer
 * @param { Stream[] } streams New definitions for the user's streams.
 * @return { Promise<Stream[] | undefined> }
 */
export const updateStreams = async (customer, streams) => {
  try {
    const response = await axios.post("/admin/streams/update", {
      streams: streams.map(stream => stream.name),
      customerid: customer.uuid,
    });
    if (response.data) {
      swal.fire("Success!", "Streams assigned successfully!", "success");
    }
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

/**
 * Fetches all streams.
 *
 * @return { Promise<Stream[] | undefined> }
 */
export const fetchGlobalStreams = async () => {
  try {
    const response = await axios.get("/admin/streams");
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

/**
 * Fetches all streams for the given customer.
 *
 * @param { Customer } customer
 * @return { Promise<Stream[] | undefined> }
 */
export const fetchCustomerStreams = async (customer) => {
  try {
    const { data: streams } = await axios.post("/admin/streams", {
      id: customer?.uuid,
    });
    return streams.length ? streams : [];
  } catch (e) {
    console.error(e);
  }
};

/**
 * Deletes the given stream.
 *
 * @param { Stream | string } stream
 * @return { Promise<Stream|undefined> }
 */
export const destroyStream = async (stream) => {
  try {
    const payload = typeof stream === 'string' ? {
      stream: { name: stream },
    } : stream;
    const response = await axios.post("/admin/streams/destroy", payload);
    if (response.data.success) {
      toastr.success("The stream has been deleted");
      return response.data.data.stream;
    } else {
      toastr.error("Stream not found");
    }
  } catch (e) {
    console.error(e);
  }
};
